import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { config } from "../../config/environment";

interface AuthGuardProps {
  children: React.ReactNode;
}

const AuthGuard: React.FC<AuthGuardProps> = ({ children }) => {
  const navigate = useNavigate();
  const isLoggedIn = localStorage.getItem(config.auth.tokenKey);
  const [hasShownToast, setHasShownToast] = useState(false);

  useEffect(() => {
    if (isLoggedIn === null && !hasShownToast) {
      navigate("/signin", { replace: true });
      setHasShownToast(true);
    }
    if (isLoggedIn && window.location.pathname === "/") {
      navigate("/", { replace: true });
    }
  }, [isLoggedIn, navigate, hasShownToast]);

  return <>{children}</>;
};

export default AuthGuard;
